import React, { useContext, useEffect, useState } from 'react'

import Icon, { BellOutlined, CommentOutlined, EditOutlined, GiftOutlined, MailOutlined, MessageOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Card, Checkbox, Col, ConfigProvider, Divider, Form, Row, Tabs, Typography } from 'antd';

import { CreateOperationDataContext } from '../../../helpers/Context.js';

export default function MarketingOperationCreateSelectChannel({ setSelectedValues, selectedValues }) {

   const [showTabs, setShowTabs] = useState(false);
   const [activeTab, setActiveTab] = useState(null)
   
   const {
      form,

      channelsOptions,
   } = useContext(CreateOperationDataContext)
   

   //mostro i campi obbligatori e verifico che non ci siano erorri per far procedere il wizard dopo che viene renderizzato il form
   const validateFieldsAfterRender = () => {

      setTimeout(() => {
         form.validateFields() 
      }, 100);

   }

   // Funzione per gestire la selezione/deselezione delle checkbox
      const handleCheckboxChange = (e) => {
         validateFieldsAfterRender();

         const { value, checked } = e.target;

         // Trova l'oggetto corrispondente nel `options` usando `value`
         const option = channelsOptions.find(opt => opt.value === value);

         if (checked && option) {
            setSelectedValues((prevSelected) => {
               const updated = [...prevSelected, option];
               setActiveTab(option.key); // 👉 attiva subito la nuova tab
               return updated;
            });
         } else {
            setSelectedValues((prevSelected) => {
               const updated = prevSelected.filter((item) => item.value !== value);

               // 👉 se la tab che hai deselezionato era attiva, attiva la prima disponibile
               if (activeTab === option.key) {
                  setActiveTab(updated[0]?.key ?? null);
               }

               return updated;
            });
         }
      };

   useEffect(() => {
      if (selectedValues.length > 0) {
         setShowTabs(true)
         setActiveTab(selectedValues[selectedValues.length - 1]["key"]);
      } else {
         setShowTabs(false)
      };
   },[selectedValues])
   
  return (
     <div className='di-operation-wizard-wrapper'>
        
         {/* ------------- scelta dei canali di operazione -------------  */}
            <Row className='mt-50'>
               <div className='flex gap-20 flex-wrap' >
                  {channelsOptions.map((option, index) => (
                     <div key={index}>
                        <ConfigProvider
                           theme={{
                              token: {
                                 colorPrimary: option.color,
                              }
                           }}
                        >
                           <Card key={option.value} bordered={false} className={`operation-chekbox-wrapper ${option.className}`}>
                              <Checkbox
                                 className='flex align-center gap-5'
                                 onChange={handleCheckboxChange}
                                 value={option.value}
                                 checked={selectedValues.some(selected => selected.value === option.value)}
                              >
                                 <div className='flex gap-10 fs-15'>
                                    {option.icon}
                                    {`${option.label}`}
                                 </div>
                              </Checkbox>
                           </Card>
                        </ConfigProvider>
                     </div>
                  ))}
               </div>
            </Row>
         {/* ------------- scelta dei canali di operazione -------------  */}
        
        {showTabs &&
            <>
               <div  className='mt-50'>
                 <Divider>
                  <div className='flex align-center'>
                     <EditOutlined className='color-primary' />
                     <Typography>Compila i campi per ogni operazione</Typography>
                  </div>
                 </Divider>
               </div>
           
               {/* ------------- tabs con le impostazioni per ogni operazione -------------  */}
               <div className='di-operations-group-tabs'>
                  <Tabs
                     onTabClick={validateFieldsAfterRender}
                     destroyInactiveTabPane={false}
                     defaultActiveKey={activeTab}
                     onChange={setActiveTab}
                     items={selectedValues}
                     activeKey={activeTab}
                     className='mt-20'
                     size="large"
                     type="card"
                  />
               </div>
               {/* ------------- tabs con le impostazioni per ogni operazione -------------  */}
            </>
         }
        
     </div>
  )
}
